import { render, staticRenderFns } from "./usergroup.vue?vue&type=template&id=7bfd422c&scoped=true&"
import script from "./usergroup.vue?vue&type=script&lang=js&"
export * from "./usergroup.vue?vue&type=script&lang=js&"
import style1 from "./usergroup.vue?vue&type=style&index=1&id=7bfd422c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd422c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bfd422c')) {
      api.createRecord('7bfd422c', component.options)
    } else {
      api.reload('7bfd422c', component.options)
    }
    module.hot.accept("./usergroup.vue?vue&type=template&id=7bfd422c&scoped=true&", function () {
      api.rerender('7bfd422c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/usergroup.vue"
export default component.exports